"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_73_33_0 = void 0;
/**
 * Migrate to 73.33.0
 *
 * remove Konfektionierung if no leitung placed
 *
 */
const migration_73_33_0 = (json) => {
    var _a, _b;
    const leitungen = (_a = json.Leitungen) === null || _a === void 0 ? void 0 : _a.filter((leitung) => !!leitung.LocalTransform && leitung.LocalTransform.length > 0);
    if ((leitungen === null || leitungen === void 0 ? void 0 : leitungen.length) === 0 && ((_b = json.Konfektionierungen) === null || _b === void 0 ? void 0 : _b.length)) {
        json.Konfektionierungen = [];
    }
    return json;
};
exports.migration_73_33_0 = migration_73_33_0;
//# sourceMappingURL=migration_73_33_0.js.map